// src/components/Header.js
import React, { useState, useEffect } from 'react';
import {
  Box,
  Flex,
  Button,
  Icon,
  IconButton,
  Image,
  useDisclosure,
} from '@chakra-ui/react';
import { FaSignOutAlt, FaUser, FaBars } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ChangePasswordModal from './ChangePasswordModal';

const Header = ({ onMenuClick, showMenuButton }) => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const logout = () => {
    // Clear tokens
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    
    // Redirect to login page
    navigate('/login');
  };

  return (
    <Box
      bg={scrolled ? 'primary.50' : 'transparent'}
      color="white"
      w="100%"
      h="60px"
      position="fixed"
      top="0"
      zIndex={3} // Ensure header is above sidebar and background
      boxShadow={scrolled ? 'sm' : 'none'}
      transition="background 0.3s, box-shadow 0.3s"
    >
      <Flex justify="space-between" align="center" maxW="1400px" mx="auto" h="100%" px={{ base: 2, md: 8 }}>
        {/* Show menu icon on mobile */}
        {showMenuButton && (
          <IconButton
            aria-label="Open navigation menu"
            icon={<FaBars />}
            onClick={onMenuClick}
            display={{ base: 'inline-flex', md: 'none' }}
            mr={2}
            variant="ghost"
            colorScheme="whiteAlpha"
          />
        )}
        {/* Company Logo or Name */}
        <Flex align="center" gap="2">
          <Image
            src="/agro-center.svg"
            alt="Kovel Agro Logo"
            h={{ base: '0px', md: '140px' }}
            mt={{ base: 0, md: 7 }}
            display={{ base: 'none', md: 'block' }}
          />
        </Flex>
        {/* Profile Actions */}
        <Flex align="center" gap="4">
          <Button
            variant="ghost"
            colorScheme="whiteAlpha"
            leftIcon={<Icon as={FaUser} />}
            display={{ base: 'none', md: 'inline-flex' }}
            onClick={onOpen}
          >
            Профіль
          </Button>
          <Button
            onClick={logout}
            variant="ghost"
            colorScheme="whiteAlpha"
            leftIcon={<Icon as={FaSignOutAlt} />}
          >
            Вийти
          </Button>
        </Flex>
      </Flex>
      <ChangePasswordModal isOpen={isOpen} onClose={onClose} />
    </Box>
  );
};

export default Header;
